import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

//Store
import { Replace, Clear } from '../../stores/countries/actions';

// Service
import CountryService from '../../services/countryService';

const useCountries = (textFilter) => {
    const { countries } = useSelector(state => state.countries_data);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const GetCountries = () => {
            setLoading(true);
            CountryService
                .Get(textFilter)
                .then( res => dispatch(Replace(res)) )
                .finally( setLoading(false) )
        }

        GetCountries();
    }, [dispatch, textFilter])

    const clear = () => dispatch(Clear())

    return {
        loading,
        countries,
        clear
    }
}

export default useCountries;